// extracted by mini-css-extract-plugin
module.exports = {"dataItem":"DataItem_dataItem__q6SjN","title":"DataItem_title__15iKZ","value":"DataItem_value__1ePn3"};